module.exports = __webpack_public_path__ + "static/img/Yoga_S940.a07bcd57.png";